import { render } from "./SubQueryTypeMaster.vue?vue&type=template&id=57b3475a&scoped=true"
import script from "./SubQueryTypeMaster.vue?vue&type=script&lang=js"
export * from "./SubQueryTypeMaster.vue?vue&type=script&lang=js"

import "./SubQueryTypeMaster.vue?vue&type=style&index=0&id=57b3475a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b3475a"]])

export default __exports__